// extracted by mini-css-extract-plugin
module.exports = {"roomPreview":"styles_roomPreview__1Qjeo","roomPreviewExpandIcon":"styles_roomPreviewExpandIcon__xXgeW"};